<template>
  <custom-actions show-back>
    <template v-if="ticket">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="作业票编号">{{ ticket.ticketNo }}</el-descriptions-item>
        <el-descriptions-item label="当前状态">
          <el-tag>{{ statuses[ticket.ticketStatus] }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="作业类型">{{ workTypes[ticket.workType] }}</el-descriptions-item>
        <el-descriptions-item
          v-for="field in detailFields"
          :key="field[0]"
          :label="field[1]"
        >
          <span class="text-value">{{ ticket[field[0]] || '—' }}</span>
        </el-descriptions-item>
      </el-descriptions>

      <el-divider>风险辨识与安全措施</el-divider>
      <el-descriptions :column="2" border>
        <el-descriptions-item
          v-for="field in safetyFields"
          :key="field[0]"
          :label="field[1]"
        >
          <span class="text-value">{{ ticket[field[0]] || '—' }}</span>
        </el-descriptions-item>
      </el-descriptions>

      <el-divider>附件与签字</el-divider>
      <el-form label-width="180px">
        <el-form-item
          v-for="field in attachmentFields"
          :key="field[0]"
          :label="field[1]"
        >
          <media-upload :value="$attachmentFiles(ticket[field[0]] || [])" readonly :update="false" />
        </el-form-item>
      </el-form>

      <el-divider>处理记录</el-divider>
      <el-table :data="ticket.recordList || []" border size="mini">
        <el-table-column label="节点" prop="nodeName" min-width="150" />
        <el-table-column label="操作人" prop="operatorName" width="120" />
        <el-table-column label="结果" width="90">
          <template #default="{ row }">
            {{ results[row.processResult] || row.processResult }}
          </template>
        </el-table-column>
        <el-table-column label="处理意见" prop="processComments" min-width="200" />
        <el-table-column label="时间" prop="ctime" width="180" />
      </el-table>

      <el-button @click="$router.back()" class="global-button mt20">取消</el-button>
    </template>
  </custom-actions>
</template>

<script>
import { statuses, workTypes, baseFields, typeFields, attachmentFields, safetyFields } from './fields'

export default {
  name: 'SpecialWorkDetail',
  data() {
    return {
      statuses,
      workTypes,
      attachmentFields,
      safetyFields,
      results: { 1: '提交', 2: '通过', 3: '驳回', 4: '完成' },
      loading: false,
      ticket: null
    }
  },
  computed: {
    ticketId() {
      return this.$route.query.ticketId
    },
    detailFields() {
      if (!this.ticket) return []
      return [
        ...baseFields,
        ['startTime', '计划开始时间'],
        ['endTime', '计划结束时间'],
        ...(typeFields[this.ticket.workType] || []),
        ['safetyAdminName', '安环管理员'],
        ['departmentLeaderName', '部门负责人'],
        ['principalName', '主要负责人'],
        ['processComments', '最近处理意见']
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      if (!this.ticketId) return
      this.loading = true
      try {
        this.ticket = await this.$axios.get(this.$apis.specialWork.detail, { ticketId: this.ticketId })
      } catch (err) {
        console.error('加载作业票详情失败', err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.text-value {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
</style>
